require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconExit.tsx
var IconExit_exports = {};
__export(IconExit_exports, {
  default: () => IconExit_default
});
module.exports = __toCommonJS(IconExit_exports);

// src/assets/monochrome/exit.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgExit = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.16664 3.4C3.96331 3.4 3.7683 3.48077 3.62453 3.62455C3.48075 3.76833 3.39998 3.96333 3.39998 4.16667V15.8333C3.39998 16.0367 3.48075 16.2317 3.62453 16.3754C3.76831 16.5192 3.96331 16.6 4.16664 16.6H7.49998C7.99703 16.6 8.39998 17.0029 8.39998 17.5C8.39998 17.9971 7.99703 18.4 7.49998 18.4H4.16664C3.48592 18.4 2.83308 18.1296 2.35173 17.6482C1.87039 17.1669 1.59998 16.5141 1.59998 15.8333V4.16667C1.59998 3.48594 1.87039 2.8331 2.35173 2.35176C2.83308 1.87041 3.48592 1.6 4.16664 1.6H7.49998C7.99703 1.6 8.39998 2.00294 8.39998 2.5C8.39998 2.99705 7.99703 3.4 7.49998 3.4H4.16664ZM12.6969 5.19694C13.0484 4.84546 13.6182 4.84546 13.9697 5.19694L18.1364 9.3636C18.3052 9.53239 18.4 9.7613 18.4 10C18.4 10.2387 18.3052 10.4676 18.1364 10.6364L13.9697 14.8031C13.6182 15.1545 13.0484 15.1545 12.6969 14.8031C12.3454 14.4516 12.3454 13.8817 12.6969 13.5303L15.3272 10.9H7.49998C7.00292 10.9 6.59998 10.4971 6.59998 10C6.59998 9.50294 7.00292 9.1 7.49998 9.1H15.3272L12.6969 6.46973C12.3454 6.11826 12.3454 5.54841 12.6969 5.19694Z", fill: "#676F7E" }) });
var exit_default = SvgExit;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconExit.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconExit = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(exit_default, {}) });
};
IconExit.displayName = "IconExit";
var IconExit_default = IconExit;
